import { createSlice } from 'utils/@reduxjs/toolkit';
import { AttributesState } from './types';
import { reducers } from './reducers';

export const initialState: AttributesState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'attributes',
  initialState,
  reducers,
});

export const { actions: attributesActions } = slice;
export const { reducer: attributesReducer } = slice;
